import ColumnsWithSeparators from './columnsWithSeparators'

export default ColumnsWithSeparators